import type { Theme } from '@mui/material';

export const styles = {
  tabHeadline: (theme: Theme) => ({
    p: '10px 16px',
    backgroundColor: theme.colors.white,
  }),

  contentWrapper: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      direction: 'row',
      spacing: 1.25,
    },
  }),

  kpiTableFooter: (theme: Theme) => ({
    mt: 2.5,
    px: 1,
    borderTop: `1px solid ${theme.colors.neutral[100]}`,
    justifyContent: 'space-between',
  }),

  contentBox: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    borderRadius: '4px',
    px: 2,
  }),

  iconFrame: (theme: Theme) => ({
    display: 'inline-flex',
    flexShrink: 0,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: theme.colors.neutral[200],
    padding: 1.125,

    '> *': {
      margin: 'auto',
      width: '100%',
      height: 'auto',
      maxHeight: '100%',
    },
  }),

  statName: (theme: Theme) => ({
    ...theme.typography.body3,
    fontSize: '13px',
    color: theme.colors.neutral[500],
  }),

  statValue: (theme: Theme) => ({
    ...theme.typography.body3,
    fontSize: '13px',
    // Ensure display does not 'jump' for switch between inspirations with one and two line texts
    lineHeight: '18px',
    minHeight: '36px',
  }),
};
